export const INSTANT_VALIDATION_BOUNDARY_NAME = '__next_instant_validation_boundary__';

//# sourceMappingURL=boundary-constants.js.map